import {CHAT_CONFIG} from "../services/ChatConfiguration";

export function agentsMetadataUrl(): string {
    return `${CHAT_CONFIG.API_URL}/agents-metadata`;
}

export function supersetGuestTokenUrl(dashboardUuid: string): string {
    return `${CHAT_CONFIG.API_URL}/superset/guest-token?dashboard_uuid=${encodeURIComponent(dashboardUuid)}`;
}

export function supersetDashboardsUrl(databagId: number): string {
    return `${CHAT_CONFIG.API_URL}/superset/dashboards?databag_id=${databagId}`;
}
